import { createAction, props } from '@ngrx/store';
import { UserDialogView } from 'src/app/landing-page/landing-page.modal';
import {
  FPDetails,
  PyResponse,
  SignInDetails,
  SignInResponse,
  SignUpDetails,
  SignUpResponse,
} from '../state/landing-page.state';

export const setActiveSignButton = createAction(
  '[LANDING_PAGE] SET_ACTIVE_SIGN_Button',
  props<{ activeSignButton: UserDialogView }>()
);

export const signIn = createAction(
  '[LANDING_PAGE] SIGN_IN_SUBMIT',
  props<{ signInDetails: SignInDetails }>()
);

export const signInSuccess = createAction(
  '[LANDING_PAGE] SIGN_IN_SUCCESS',
  props<{ signInResponse: SignInResponse }>()
);

export const signInError = createAction('[LANDING_PAGE] SIGN_IN_ERROR');

export const signUp = createAction(
  '[LANDING_PAGE] SIGN_UP',
  props<{ signUpDetails: SignUpDetails }>()
);

export const signUpSuccess = createAction(
  '[LANDING_PAGE] SIGN_UP_SUCCESS',
  props<{ signUpResponse: SignUpResponse }>()
);

export const signUpError = createAction('[LANDING_PAGE] SIGN_UP_ERROR');

export const resetPassword = createAction(
  '[LANDING_PAGE] RESET_PASSWORD',
  props<{ fpDetails: FPDetails }>()
);

export const resetPasswordSuccess = createAction(
  '[LANDING_PAGE] RESET_PASSWORD_SUCCESS'
);

export const resetPasswordError = createAction(
  '[LANDING_PAGE] RESET_PASSWORD_ERROR'
);

export const requestOTP = createAction(
  '[LANDING_PAGE] REQUEST_OTP',
  props<{ emailId: string }>()
);

export const requestOTPSuccess = createAction(
  '[LANDING_PAGE] REQUEST_OTP_SUCCESS'
);

export const requestOTPError = createAction('[LANDING_PAGE] REQUEST_OTP_ERROR');
